<template>
    <div class="video_meeting">
        <header-nav ref="router" theme="1"></header-nav>
        <base-login></base-login>
        <el-container class="container">
            <el-header height="147px">
                <div class="breadcrumb-wrap">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
                        <el-breadcrumb-item
                        ><a href="/seeker/person.html">个人中心</a></el-breadcrumb-item
                        >
                        <el-breadcrumb-item>企业邀约</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <kzptabs
                        :tabs-list="tabsList"
                        :tabs-index="activeName * 1"
                        @changtab="tabChangHandle"
                ></kzptabs>
            </el-header>
            <el-main class="page-main" v-loading="initPage">
                <div class="table-wrap">
                    <div class="infinite-list" v-if="activeName === 0"
                         :style="'overflow:auto; min-height:' + grid.height + 'px;'">
                        <div class="filter-wrap">
                            <el-select
                                    v-model="filter[activeName].state"
                                    filterable
                                    placeholder="状态选择"
                                    @change="refresh()">
                                <el-option
                                        v-for="item in selectOptions[activeName]"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>

                        <template v-if="tableData[activeName].length > 0">
                            <div
                                    class="infinite-list-wrap"
                                    v-infinite-scroll="loadNextPage"
                                    infinite-scroll-immediate="false">
                                <div
                                        v-for="(item_card, index) in tableData[activeName]"
                                        :key="index"
                                        class="infinite-list-item">
                                    <el-card shadow="hover">
                                        <div class="infinite-top-tip">
                                            <span>类型：视频双选会&nbsp;</span>
                                            <p style="float: right">
                        <span class="resume-tip">邀请时间：{{ item_card.create_time }}</span>
                                                <span
                                                        class="resume-tip"
                                                        v-if="!item_card.is_over && item_card.state == 1"
                                                >&emsp;面试时间：{{ item_card.interview_time }}</span
                                                >
                                            </p>
                                        </div>
                                        <div class="tab-list">
                                            <div class="tab-list-tit">
                                                <p style="margin-bottom: 8px">
                                                    <span @click="goDetail('job',item_card.publish_id)" class="text-title">
                                                      {{item_card.job_name || '--'}}
                                                    </span>
                                                    &emsp;
                                                    <span @click="goDetail('company',item_card.company_id)" class="text-title">
                                                      {{item_card.company_name || '--'}}
                                                    </span>
                                                </p>
                                                <p class="text-list">
                                                    <span @click="goDetail('jobfair',item_card.video_jobfair_id)">{{ item_card.video_jobfair_name }}</span>
                                                </p>
                                            </div>
                                            <div class="tab-btns">
                                                <el-link type="primary" :underline="false">
                                                    {{item_card.state | stateFilter('video', item_card.is_over,
                                                    item_card.interview_state)}}
                                                </el-link>
                                                <p class="tab-btns-b" v-if="!item_card.is_over && item_card.state == 0">
                                                    <el-button v-for="(item, index) in tabsList[activeName].operation"
                                                               :key="index"
                                                               @click.native.stop.prevent="handleVideoMark(item, item_card)"
                                                               :type="item.type ? item.type : 'primary'" size="mini">
                                                        {{ item.label }}&nbsp;
                                                    </el-button>
                                                </p>
                                            </div>
                                        </div>
                                    </el-card>
                                </div>

                                <el-row
                                        style="height: 50px"
                                        v-if="loading"
                                        v-loading="loading"
                                        element-loading-text="拼命加载中"
                                        element-loading-spinner="el-icon-loading"></el-row>

                                <el-divider v-if="pageParams[activeName].noMore">
                                    这是我的底线哦~
                                </el-divider>
                            </div>
                        </template>

                        <el-divider v-else>
                            <span v-show="!initPage">暂无数据</span>
                        </el-divider>
                    </div>
                    <div class="infinite-list" v-else-if="activeName === 1"
                         :style="'overflow:auto; min-height:' + grid.height + 'px;'">
                        <div class="filter-wrap">
                            <el-select
                                    v-model="filter[activeName].state"
                                    filterable
                                    placeholder="状态选择"
                                    @change="refresh()"
                            >
                                <el-option
                                        v-for="item in selectOptions[activeName]"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <template v-if="tableData[activeName].length > 0">
                            <div class="infinite-list-wrap" v-infinite-scroll="loadNextPage"
                                 infinite-scroll-immediate="false">
                                <div v-for="(item_card, index) in tableData[activeName]" :key="index"
                                     class="infinite-list-item">
                                    <el-card shadow="hover">
                                        <div class="infinite-top-tip">
                                            <span>类型：简历投递&nbsp;</span>
                                            <p style="float: right">
                                                <span class="resume-tip">邀请时间：{{ item_card.create_time }}</span>
                                            </p>
                                        </div>
                                        <div class="tab-list">
                                            <div style="padding: 5px 0; cursor: pointer">
                                                <p style="margin-bottom: 8px">
                                                    <span class="text-title" @click="goDetail('job',item_card.publish_id)">{{item_card.job_name || '--'}}</span>
                                                    &emsp;
                                                    <span class="text-title">{{item_card.salary || '--'}}</span>
                                                </p>

                                                <p class="text-list">
                                                    <span v-if="item_card.company_name" @click="goDetail('company',item_card.company_id)">
                                                      <i class="iconfont iconqiye2"></i>
                                                      {{ item_card.company_name }}
                                                    </span>
                                                </p>
                                            </div>
                                            <div class="tab-btns">
                                                <el-link type="primary" :underline="false">
                                                    {{ item_card.state | stateFilter('resume') }}
                                                </el-link>

                                                <p class="tab-btns-b"
                                                   v-if="item_card.state == 0 || item_card.state == 2">
                                                    <el-button v-for="(item, index) in tabsList[activeName].operation"
                                                               :key="index"
                                                               @click.native.stop.prevent="handleMark(item, item_card)"
                                                               :type="item.type ? item.type : 'primary'" size="mini">
                                                        {{ item.label }}&nbsp;
                                                    </el-button>
                                                </p>
                                            </div>
                                        </div>
                                    </el-card>
                                </div>

                                <el-row
                                        style="height: 50px"
                                        v-if="loading"
                                        v-loading="loading"
                                        element-loading-text="拼命加载中"
                                        element-loading-spinner="el-icon-loading"
                                ></el-row>

                                <el-divider v-if="pageParams[activeName].noMore">
                                    这是我的底线哦~
                                </el-divider>
                            </div>
                        </template>

                        <el-divider v-else>
                            <span>暂无数据</span>
                        </el-divider>
                    </div>
                </div>
                <float-window
                        :items="floatData.item"
                        :curr-item="floatData.currItem"
                ></float-window>
            </el-main>
        </el-container>
    </div>
</template>

<script>
  import {mapState} from 'vuex'

  import Kzptabs from '@/components/KzpTabs'
  import FloatWindow from '@/components/FloatWindow/FloatWindow'

  export default {
    name: 'c_invited',
    components: {
      kzptabs: Kzptabs,
      floatWindow: FloatWindow,
    },
    computed: {
      ...mapState({
        user: (state) => state.user,
      }),
    },
    data () {
      return {
        initPage: true,
        loading: false,
        grid: {
          height: 500,
        },
        activeName: 0,

        filter: [
          {
            pageNo: 1,
            pageSize: 10,
            type: '',
            state: '',
          },
          {
            pageNo: 1,
            pageSize: 10,
            type: '',
            state: '',
          },
        ],
        tableData: [[], []],
        selectOptions: [
          [
            {label: '全部状态', value: ''},
            {label: '待确认', value: '0'},
            {label: '待面试', value: '1'},
            {label: '已面试', value: '3'},
            {label: '已拒绝', value: '2'},
          ],
          [
            {label: '全部状态', value: ''},
            {label: '待投递', value: '0,2'},
            {label: '已投递', value: '1'},
            {label: '已拒绝', value: '-1'},
          ],
        ],
        tabsList: [
          {
            label: '视频双选会邀约',
            type: 'video',
            operation: [
              {label: '接受', state: 1},
              {label: '拒绝', type: 'warning', state: 2},
            ],
          },
          {
            label: '简历投递邀请',
            type: 'resume',
            operation: [
              {label: '确认投递', state: 1},
              {label: '不接受', type: 'warning', state: -1},
            ],
          },
        ],
        floatData: {
          item: [
            {
              label: '最近投递',
              link: '/seeker/person/r_delivery.html',
              icon: 'icontoudilishi',
            },
            {
              label: '我的收藏',
              link: '/seeker/person/m_collection.html',
              icon: 'iconshoucang',
            },
            {
              label: '我的申请',
              link: '/seeker/person/m_apply.html',
              icon: 'iconshenqing',
            },
            {
              label: '企业邀约',
              link: '/seeker/person/c_invited.html',
              icon: 'iconact_yaoyue',
            },
          ],
          currItem: '3',
        },
        pageParams: [
          {noMore: false, pageNo: 1, pageSize: 8},
          {noMore: false, pageNo: 1, pageSize: 8},
          {noMore: false, pageNo: 1, pageSize: 8},
          {noMore: false, pageNo: 1, pageSize: 8},
        ],
        tabsCount: ['', ''],
      }
    },
    mounted: function () {
      this.getInvitationFn()
      this.initHeight()
    },
    filters: {
      stateFilter: function (state, type, is_over, interview_state) {
        let stateTxt = ''
        if (type === 'resume') {
          if (state * 1 === 0 || state * 1 === 2) {
            stateTxt = '待投递'
          } else if (state * 1 === 1) {
            stateTxt = '已投递'
          } else if (state * 1 === -1) {
            stateTxt = '已拒绝'
          }
        } else if (type === 'video') {
          //待确认、待面试、已面试、已拒绝
          if (is_over) {
            stateTxt = '已结束'
          } else {
            if (state * 1 === 0) {
              stateTxt = '待确认'
            } else if (state * 1 === 1 && interview_state * 1 < 1) {
              stateTxt = '待面试'
            } else if (state * 1 === 1 && interview_state * 1 === 1) {
              stateTxt = '面试中'
            } else if (state * 1 === 2) {
              stateTxt = '已拒绝'
            }
            if (interview_state * 1 === 2) stateTxt = '已面试'
          }
        }
        return stateTxt
      },
    },
    methods: {
      getList: function (method, params) {
        let _self = this
        return new Promise((resolve) => {
          this.$util
            .get('kzp_person', method, params)
            .then((res) => {
              if (res && res.code === 1) {
                resolve(res)
              } else {
                resolve({code: -1, data: []})

                if (res.msg) {
                  _self.$message.error(res.msg)
                }
              }
            })
            .catch(() => {
              // 处理不提示的错误!
            })
        })
      },

      getInvitationFn (type) {
        let _self = this
        let filter = _self.filter[_self.activeName]
        if (type === 'page') {
          filter.pageNo = 1
        }

        _self.loading = true
        filter.type = _self.tabsList[_self.activeName].type

        let params = Object.assign({}, filter)
        /*面试已结束*/
        if (params.state == 3) {
          params.state = ''
          params.interview_state = 2
        }

        _self.getList('get_invitation', params).then(function (res) {
          _self.loading = false

          if (res.data.total) {
            if (filter.pageNo === 1) {
              _self.$set(_self.tableData, _self.activeName, res.data.items)
              _self.initPage = false
            } else {
              _self.tableData[_self.activeName] = [
                ..._self.tableData[_self.activeName],
                ...res.data.items,
              ]
            }
            _self.$set(_self.tabsCount, _self.activeName, res.data.total)
          }

          if (res.data.total <= _self.tableData[_self.activeName].length) {
            filter.noMore = true
          }
        })
      },

      tabChangHandle (tab) {
        this.handleClick(tab)
      },
      handleClick (tab) {
        if (tab && tab.index >= 0) {
          this.activeName = tab.index || 0
          if (this.tableData[this.activeName].length > 0) {
            return true
          }
          this.initPage = true
          this.refresh()
        }
      },
      refresh: function () {
        this.getInvitationFn('page')
      },
      initHeight () {
        const height =
          window.innerHeight -
          document.querySelector('.header-nav').clientHeight -
          document.querySelector('.el-header').clientHeight -
          60
        this.grid.height = height
      },
      goDetail (type, id) {
        if (type === 'jobfair') {
          this.$refs['router'].subpageto('jobfair_detail', {video_jobfair_id: id})
        } else if (type === 'job') {
          this.$refs['router'].subpageto('jobfair_job', {publish_id: id})
        } else if (type === 'company') {
          this.$refs['router'].subpageto('company_detail', {company_id: id})
        }
      },
      handleVideoMark (item, video) {
        let _self = this,
          title = '',
          tip = ''
        if (item.state == 1) {
          title = '是否确定接受【' + video.job_name + '】视频邀约？'
          tip = '操作成功'
        } else {
          title = '是否确定拒绝【' + video.job_name + '】视频邀约？'
          tip = '操作成功'
        }

        let params = {
          invitation_apply_id: video.invitation_apply_id,
          state: item.state,
        }

        this.confirmFn(
          {
            tip: title,
          },
          function () {
            _self.setInvitation('accept', tip, params)
          }
        )
      },

      handleMark (item, invite) {
        let _self = this,
          title = '',
          tip = ''
        if (item.state > 0) {
          title = '是否确定投递【' + invite.job_name + '】？'
          tip = '投递成功'
        } else {
          title = '是否确定拒绝【' + invite.job_name + '】？'
          tip = '操作成功'
        }

        let params = {
          invite_id: invite.invite_id,
          state: item.state,
        }

        this.confirmFn(
          {
            tip: title,
          },
          function () {
            _self.setInvitation('deal_my_invite', tip, params)
          }
        )
      },

      setInvitation (action, tip, params) {
        this.$util
          .get('kzp_person', action, params)
          .then((res) => {
            const {code, data, msg} = res
            if (code === 1) {
              this.$message({
                message: tip,
                type: 'success',
              })
              this.refresh()
            } else {
              this.$message.error(msg)
            }
          })
          .catch(() => {
            // 处理不提示的错误!
          })
      },
      confirmFn (option, success, cancel) {
        this.$confirm(option.tip || '是否确定执行？', option.title || '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (success && typeof success === 'function') {
              success()
            }
          })
          .catch(() => {
            if (cancel && typeof cancel === 'function') {
              cancel()
            }
          })
      },

      loadNextPage () {
        let params = this.pageParams[this.activeName]
        if (this.loading || params.noMore) {
          return false
        }
        params.pageNo++
        this.getInvitationFn()
      },
    },
  }
</script>

<style lang="scss" scoped>
    .video_meeting {
        .page-tit {
            margin: 0;
            padding: 10px 0;
            font-size: 16px;
            font-weight: bold;
        }

        .breadcrumb-wrap {
            padding: 25px 0px;
        }

        .table-wrap {
            margin-top: 15px;

            .filter-wrap {
                margin-bottom: 10px;
            }
        }

        .infinite-top-tip {
            font-size: 12px;
            line-height: 17px;
            margin-bottom: 10px;
            color: #999;
        }

        .infinite-list-item {
            margin-bottom: 8px;

            .tab-list {
                display: table;
                width: 100%;
                vertical-align: middle;

                .tab-list-tit {
                    padding: 5px 0;

                    span {
                        cursor: pointer;

                        &:hover {
                            color: #007FFF;
                        }
                    }
                }
            }

            .tab-list > div {
                display: table-cell;
                vertical-align: middle;
                border: none;
            }

            .text-title{
              font-size: 16px;
              font-weight: bold;

              &:hover{
                color: #409eff;
              }
            }

            .text-list {
                color: #999;

                & > span {
                    margin-right: 10px;
                    font-size: 14px;
                }

                .iconfont {
                    font-size: 13px;
                }
            }

            img {
                width: 100%;
                max-height: 100%;
            }

            .el-card__body {
                padding: 20px;
            }

            .tab-btns {
                text-align: right;

                .tab-btns-b {
                    margin-top: 5px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/seeker/person/c_invited/App.vue